import React from "react";
import "../assets/css/PhraseAccroche.css"; // Import du CSS dédié
import { useTranslation } from "react-i18next";

const PhraseAccroche = () => {
  const { t } = useTranslation();
  return (
    <div className="phrase-accroche" data-aos="fade-up">
      <div className="quote-box">
        <span className="quote-left">❝</span>
        <p>{t("PhraseAccroche")}</p>
        <span className="quote-right">❞</span>
      </div>
    </div>
  );
};

export default PhraseAccroche;
